import { useMutation } from '@tanstack/react-query';
import { generateVoucher } from '@/api/voucher/voucher';

export const useGenerateVoucher = () => {
  const { mutate, data, isLoading, isError, isSuccess } = useMutation({
    mutationFn: generateVoucher,
  });

  return {
    generateVoucher: mutate,
    voucherCode: data?.voucher,
    isGenerating: isLoading,
    isGenerateError: isError,
    isGenerateSuccess: isSuccess,
  };
};
